export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categoryName: string;
  image: string;
  author: string;
  publishDate: string;
  readCount: string;
  tags: string[];
  isFeatured: boolean;
}

export const articleCategories = [
  { id: 'all', name: '全部资讯' },
  { id: 'news', name: '平台公告' },
  { id: 'guide', name: '游戏攻略' },
  { id: 'event', name: '优惠活动' },
  { id: 'industry', name: '行业动态' },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '九游娱乐全新版本上线，游戏体验全面升级',
    summary: '经过数月精心打磨，九游娱乐平台迎来重大版本更新。全新界面设计、更流畅的游戏加载速度、更丰富的游戏内容，为玩家带来前所未有的娱乐体验。',
    content: `<p>亲爱的九游娱乐玩家朋友们：</p><p>我们非常激动地宣布，九游娱乐平台全新版本正式上线！经过数月精心打磨，本次更新带来了全方位的体验升级。</p><h3>全新界面，焕然一新</h3><p>全新设计的用户界面更加简洁直观，游戏分类更加清晰，让您能够快速找到心仪的游戏。首页个性化推荐算法升级，为您精准推送最合适的游戏内容。</p><h3>性能飞跃，流畅加倍</h3><p>技术团队对底层架构进行了全面优化，游戏加载速度提升60%，画面帧率更加稳定。无论您使用何种设备，都能享受丝滑流畅的游戏体验。</p><h3>海量新游，精彩不断</h3><p>本次更新同步上线了多款精品新游戏，涵盖棋牌、电子、捕鱼、体育竞猜等多个品类。每款游戏都经过严格测试，确保公平公正。</p><h3>会员体系焕新</h3><p>全新会员等级体系上线，更多专属福利、更高返水比例、更快提现速度。老会员自动升级，福利无缝衔接。</p><p>九游娱乐，始终致力于为您提供最优质的游戏体验。感谢您一直以来的支持与信任！</p>`,
    category: 'news',
    categoryName: '平台公告',
    image: 'https://readdy.ai/api/search-image?query=Modern%20gaming%20platform%20interface%20with%20sleek%20dark%20theme%2C%20futuristic%20holographic%20displays%2C%20golden%20accents%2C%20clean%20minimal%20tech%20aesthetic%2C%20warm%20ambient%20lighting%2C%20professional%20product%20showcase%2C%20cinematic%20composition&width=1200&height=600&seq=article-new-version&orientation=landscape',
    author: '九游娱乐官方',
    publishDate: '2026-08-01',
    readCount: '128,456',
    tags: ['版本更新', '平台公告', '新功能'],
    isFeatured: true,
  },
  {
    id: 'article-2',
    title: '【攻略】百家乐高手进阶：从入门到精通',
    summary: '百家乐作为最受欢迎的真人视讯游戏之一，掌握正确的策略至关重要。本文为您详细解析百家乐的玩法规则、投注技巧和资金管理方法。',
    content: `<p>百家乐作为最受欢迎的真人视讯游戏之一，以其简单易学、节奏快速而备受玩家喜爱。但想要在百家乐中持续盈利，掌握正确的策略至关重要。</p><h3>一、百家乐基础规则</h3><p>百家乐使用8副扑克牌，每局庄家和闲家各发2-3张牌。点数计算规则：A为1点，2-9为面值，10/J/Q/K为0点。取个位数为最终点数，最接近9点者获胜。</p><h3>二、核心投注策略</h3><p><strong>1. 顺势而为法：</strong>观察最近10局的走势，跟随趋势下注。如果庄家连赢，继续押庄；如果出现单跳，则跟随单跳节奏。</p><p><strong>2. 马丁格尔法：</strong>每次输后加倍下注，直到赢回本金。此策略需要充足的资金储备，建议设定止损线。</p><p><strong>3. 平注法：</strong>每局固定金额下注，不因输赢改变。这是最稳健的策略，适合新手玩家。</p><h3>三、资金管理</h3><p>合理规划每日游戏预算，严格执行止损止盈纪律。建议单次游戏预算不超过总资金的20%，连续盈利3局后适当减注锁定利润。</p><h3>四、心态修炼</h3><p>保持冷静理性的心态，不因短期输赢影响判断。记住：百家乐是一场马拉松，不是百米冲刺。</p><p>希望这篇攻略能帮助您在百家乐中获得更好的游戏体验！</p>`,
    category: 'guide',
    categoryName: '游戏攻略',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20baccarat%20table%20close-up%20with%20playing%20cards%20and%20chips%2C%20luxurious%20green%20felt%2C%20golden%20details%2C%20warm%20mood%20lighting%2C%20professional%20casino%20photography%2C%20clean%20composition%2C%20sophisticated%20atmosphere&width=1200&height=600&seq=article-baccarat-guide&orientation=landscape',
    author: '九游攻略组',
    publishDate: '2026-07-28',
    readCount: '256,789',
    tags: ['百家乐', '攻略', '真人视讯'],
    isFeatured: true,
  },
  {
    id: 'article-3',
    title: '八月盛夏狂欢，充值即送高达100%红利',
    summary: '炎炎夏日，九游娱乐为回馈广大玩家的支持，特别推出八月盛夏狂欢活动。充值即送超高比例红利，更有每日抽奖、积分翻倍等多重福利等您来拿。',
    content: `<p>炎炎夏日，热情不减！九游娱乐为回馈广大玩家的支持与厚爱，特别推出"八月盛夏狂欢"大型回馈活动。</p><h3>活动一：首充红利100%</h3><p>活动期间，新用户首次充值任意金额，即可获得100%充值红利，最高赠送888元！红利可直接用于游戏，让您的欢乐加倍。</p><h3>活动二：每日充值返利</h3><p>每日充值满100元，即可获得10%额外返利；满500元返利15%；满1000元返利20%。返利金额无上限，充得越多返得越多。</p><h3>活动三：幸运转盘抽奖</h3><p>每日完成任意游戏对局，即可获得一次幸运转盘抽奖机会。奖品包括：现金红包、免费筹码、实物礼品等。100%中奖，每日可参与3次。</p><h3>活动四：积分翻倍</h3><p>活动期间，所有游戏积分获取翻倍。积分可用于兑换各种精美礼品和游戏道具。</p><h3>活动时间</h3><p>2026年8月1日 - 2026年8月31日</p><p>快来加入九游娱乐，开启您的盛夏狂欢之旅吧！</p>`,
    category: 'event',
    categoryName: '优惠活动',
    image: 'https://readdy.ai/api/search-image?query=Summer%20celebration%20party%20theme%20with%20golden%20confetti%20and%20ribbons%2C%20warm%20sunset%20colors%2C%20festive%20atmosphere%2C%20luxurious%20gold%20and%20red%20decorations%2C%20clean%20elegant%20composition%2C%20excitement%20and%20energy&width=1200&height=600&seq=article-summer-event&orientation=landscape',
    author: '九游活动组',
    publishDate: '2026-08-01',
    readCount: '389,012',
    tags: ['优惠活动', '充值返利', '盛夏狂欢'],
    isFeatured: true,
  },
  {
    id: 'article-4',
    title: '2026年在线娱乐行业发展趋势分析',
    summary: '随着技术的不断进步和用户需求的持续升级，2026年在线娱乐行业呈现出新的发展趋势。本文从技术创新、用户体验和合规发展三个维度进行深度分析。',
    content: `<p>2026年，全球在线娱乐行业持续高速发展。作为行业领先平台，九游娱乐始终关注行业前沿动态，以下是本年度最重要的几大趋势。</p><h3>一、AI技术深度应用</h3><p>人工智能技术在游戏推荐、风控安全、客服服务等领域的应用更加深入。九游娱乐已率先引入AI智能客服系统，实现7×24小时秒级响应。</p><h3>二、移动端体验优化</h3><p>移动端用户占比持续攀升至78%，各大平台纷纷加大移动端投入。九游娱乐新一代移动端采用原生渲染技术，加载速度和操作流畅度行业领先。</p><h3>三、区块链技术融合</h3><p>区块链技术在游戏公平性验证、资产安全存储等方面的应用日趋成熟，为行业带来更高的透明度和信任度。</p><h3>四、社交化游戏体验</h3><p>游戏不再是孤立的娱乐活动，社交功能成为标配。九游娱乐的游戏大厅已支持实时语音、好友对战、排行榜等社交功能。</p><h3>五、合规化进程加速</h3><p>各国监管政策不断完善，合规经营成为行业基本门槛。九游娱乐始终坚持合法合规运营，持有正规运营资质。</p><p>九游娱乐将持续关注行业发展，不断创新，为玩家提供更优质的服务。</p>`,
    category: 'industry',
    categoryName: '行业动态',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20digital%20entertainment%20concept%20with%20holographic%20data%20visualization%2C%20abstract%20network%20connections%2C%20warm%20golden%20and%20deep%20blue%20color%20scheme%2C%20clean%20tech%20aesthetic%2C%20modern%20minimal%20composition%2C%20professional%20business%20vibe&width=1200&height=600&seq=article-industry-trend&orientation=landscape',
    author: '九游研究院',
    publishDate: '2026-07-20',
    readCount: '95,234',
    tags: ['行业趋势', '分析', '2026'],
    isFeatured: false,
  },
  {
    id: 'article-5',
    title: '【攻略】老虎机高手必知的五大技巧',
    summary: '想要在老虎机游戏中获得更好的体验？本文为您揭秘老虎机高手的五大核心技巧，助您玩转各类老虎机游戏。',
    content: `<p>老虎机是最受欢迎的电子游戏类型之一，简单的操作下蕴含着丰富的策略。以下是资深玩家总结的五大核心技巧。</p><h3>技巧一：选择高RTP游戏</h3><p>RTP（Return to Player）是游戏的理论回报率。优先选择RTP在96%以上的游戏，长期来看能够获得更好的游戏体验。九游娱乐平台所有游戏均公开RTP数据。</p><h3>技巧二：合理利用免费旋转</h3><p>免费旋转是老虎机最核心的奖励机制。遇到免费旋转触发时，不要急于跳过动画，享受每一转带来的惊喜。</p><h3>技巧三：控制单次投注金额</h3><p>建议单次投注不超过总预算的2%，这样可以确保足够的游戏时长。不要因为短期未中奖就盲目加注。</p><h3>技巧四：了解特殊符号</h3><p>Wild（万能符号）、Scatter（分散符号）、Bonus（奖励符号）各有不同的功能。熟悉每款游戏的符号系统，能够更好地把握中奖机会。</p><h3>技巧五：设定盈利目标</h3><p>每次游戏前设定明确的盈利目标和止损线。达到目标后果断离场，不要恋战。</p><p>祝您在九游娱乐的老虎机世界中好运连连！</p>`,
    category: 'guide',
    categoryName: '游戏攻略',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20slot%20machine%20reels%20with%20cherries%20and%20sevens%2C%20bright%20neon%20lights%2C%20golden%20coins%20cascading%2C%20exciting%20casino%20atmosphere%2C%20vibrant%20colors%2C%20clean%20composition%2C%20dynamic%20energy&width=1200&height=600&seq=article-slots-tips&orientation=landscape',
    author: '九游攻略组',
    publishDate: '2026-07-15',
    readCount: '178,345',
    tags: ['老虎机', '攻略', '技巧'],
    isFeatured: false,
  },
  {
    id: 'article-6',
    title: '九游娱乐荣获"2026年度最佳游戏平台"大奖',
    summary: '在刚刚落幕的2026亚洲数字娱乐产业大会上，九游娱乐凭借卓越的产品品质和优质的用户服务，荣获"年度最佳游戏平台"殊荣。',
    content: `<p>2026年7月10日，亚洲数字娱乐产业大会在新加坡圆满落幕。九游娱乐凭借卓越的产品品质、创新的技术实力和优质的用户服务，从众多参选平台中脱颖而出，荣获"2026年度最佳游戏平台"大奖。</p><h3>权威评选，实至名归</h3><p>本次评选由亚洲数字娱乐协会主办，评审团由来自12个国家和地区的行业专家组成。评选维度包括：产品体验、技术创新、用户满意度、安全合规和社会责任五个方面。九游娱乐在全部维度均获得高分评价。</p><h3>用户至上，持续创新</h3><p>九游娱乐CEO在领奖时表示："这份荣誉属于每一位信任和支持九游娱乐的玩家。未来我们将继续坚持'用户至上'的理念，不断创新，为玩家提供更优质的娱乐体验。"</p><h3>行业标杆，引领发展</h3><p>评审委员会评价称："九游娱乐在游戏品质、技术架构和安全保障方面均处于行业领先水平，为用户创造了安全、公平、愉悦的游戏环境，是行业发展的优秀标杆。"</p><p>此次获奖是对九游娱乐多年来坚持品质路线的最好肯定。我们将继续努力，不负每一位玩家的期待！</p>`,
    category: 'news',
    categoryName: '平台公告',
    image: 'https://readdy.ai/api/search-image?query=Prestigious%20award%20ceremony%20stage%20with%20golden%20trophy%20and%20spotlights%2C%20elegant%20atmosphere%2C%20celebration%20moment%2C%20warm%20dramatic%20lighting%2C%20professional%20event%20photography%2C%20clean%20composition%2C%20achievement%20and%20success&width=1200&height=600&seq=article-award&orientation=landscape',
    author: '九游娱乐官方',
    publishDate: '2026-07-10',
    readCount: '421,567',
    tags: ['获奖', '荣誉', '行业认可'],
    isFeatured: true,
  },
];